<template>
  <div id="app" class="lang-jp">
    <div class="pc-container" :class="[`-${$route.name} -${$route.params.lang}`]" :style="{'min-height': mainHeight}">
      <div class="container" :class="[{'menu-opend' : isOpen}, {'term3': termType === 3}]" :style="{'min-height': mainHeight}">
        <main-header />
        <router-view class="main" />
        <main-footer />
      </div>
    </div>
    <modal />
    <modal-terms />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import MainHeader from '@/components/the-header.vue'
import MainFooter from '@/components/the-footer.vue'
import Modal from '@components/modal'
import ModalTerms from '@components/modals/modal-terms'

export default {
  components: {
    MainHeader,
    MainFooter,
    Modal,
    ModalTerms,
  },
  computed: {
    ...mapState('terms', ['isShowTerms']),
    ...mapGetters('modal', ['isShowModal']),
    ...mapGetters('menu', ['isOpen', 'termType'])
  },
  watch: {
    isShowTerms() {
      document.body.style.overflow = this.isShowTerms ? 'hidden' : ''
      document.body.style.position = this.isShowTerms ? 'fixed' : ''
      document.body.style.height = this.isShowTerms ? '100%' : ''
    },
    isShowModal() {
      document.body.style.overflow = this.isShowModal ? 'hidden' : ''
      document.body.style.position = this.isShowModal ? 'fixed' : ''
      document.body.style.height = this.isShowModal ? '100%' : ''
    }
  },
  data() {
    return {
      mainHeight: "100vh"
    }
  },
  created(){
    this.loginInit()
    this.menuInit()
    this.mainHeight = window.innerHeight + "px";
  },
  methods:{
    ...mapActions('login', { loginInit:'init' }),
    ...mapActions('menu', { menuInit:'init' }),
  }
}
</script>

<style lang="scss">
.lang-jp {
  font-family: $ff-lang-jp;
}
.pc-container {
  width: 100%;
  height: 100%;
  background-position: 99% 99%;

  @include max-screen(641px) {
    background: transparent;
  }
}
.container {
  position: relative;
  width: $base-w;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  background-image: url(#{$img-path}bg_main-top.png), url(#{$img-path}bg_main-base.jpg);
  background-repeat: no-repeat, repeat-y;
  background-position: 0 0, 0 0;
  display: flex;
  flex-direction: column;
  &.menu-opend {
    height: 1310px;
    &.term3 {
      height: 1390px;
    }
  }
}
.main {
  flex-grow: 1;
  margin-top: 212px;
}
.-heroes {
  .main{
    min-height: 720px;
  }
  .main-footer {
    margin-top: 0;
    .bottom-box {
      margin-top: 0;
    }
  }
}
.-ja-JP {
  .container.menu-opend {
    height: 1514px;
    &.term3 {
      height: 1610px;
    }
  }
}
.-de-DE {
  .container.menu-opend {
    height: 1450px;
    &.term3 {
      height: 1540px;
    }
  }
}
.-en-US {
  .container.menu-opend {
    height: 1650px;
    &.term3 {
      height: 1740px;
    }
  }
}
.-en-GB {
  .container.menu-opend {
    height: 1620px;
    &.term3 {
      height: 1710px;
    }
  }
}
.-fr-CA {
  .container.menu-opend {
    height: 1400px;
    &.term3 {
      height: 1495px;
    }
  }
}
.-es-ES{
  .container.menu-opend {
    height: 1330px;
    &.term3 {
      height: 1420px;
    }
  }
}
.-es-MX,
.-fr-FR,
.-it-IT {
  .container.menu-opend {
    height: 1364px;
    &.term3 {
      height: 1454px;
    }
  }
}
.-pt-BR {
  .container.menu-opend {
    height: 1464px;
    &.term3 {
      height: 1544px;
    }
  }
}
</style>
